import React from 'react'
import { string, array, oneOf } from 'prop-types'
import { Highlight, ButtonGroup } from '@/component/Primitive/Events'
import styles from './EventTextBlock.module.scss'
import cx from 'classnames'
import Stack from '@/component/Primitive/Stack'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'

export const EventTextBlock = ({
  title,
  subtitle,
  description,
  theme,
  buttonGroup,
  align
}) => {
  return (
    <div
      className={cx(
        styles.EventTextBlock,
        theme === 'dark' && styles.dark,
        align === 'center' && styles.center
      )}
    >
      <Container
        center
        size="wide"
        gutter
        className={cx(styles.EventTextBlockInner)}
      >
        <div className={styles.ContentWrapper}>
          <Stack className={styles.Content} gap="medium">
            <Stack gap="tiny">
              {title && (
                <Type
                  as="h1"
                  size={['heading5', 'heading2']}
                  weight="medium"
                  className={styles.Title}
                >
                  <Highlight>{title}</Highlight>
                </Type>
              )}
              {subtitle && (
                <Type
                  as="h2"
                  size={['body2', 'body3']}
                  weight="medium"
                  className={styles.Subtitle}
                >
                  {subtitle}
                </Type>
              )}
            </Stack>
            {description && (
              <Type size={['body2', 'body2']}>{description}</Type>
            )}
            {!!buttonGroup?.length && <ButtonGroup group={buttonGroup} />}
          </Stack>
        </div>
      </Container>
    </div>
  )
}

EventTextBlock.propTypes = {
  title: string,
  subtitle: string,
  description: string,
  theme: string,
  buttonGroup: array,
  align: oneOf(['center', 'left'])
}
